import { Pipe, PipeTransform } from '@angular/core';

/**
 * Humanises the driver rule keys carried by DriverRulesCheckDTO. Mirrors
 * the four rules defined in
 * agnus-server/preferredPartner/eligibility/driver.go (lines 44-50).
 */
@Pipe({ name: 'driverRuleName' })
export class DriverRuleNamePipe implements PipeTransform {
  private static readonly map: Record<string, string> = {
    noLoadRejections: 'No load rejections',
    noMissedAcceptances: 'No missed acceptances',
    gpsAlwaysOn: 'GPS always on',
    noLateArrivals: 'No late arrivals',
  };

  public transform(rule: string | null | undefined): string {
    if (!rule) {
      return '';
    }
    return DriverRuleNamePipe.map[rule] ?? rule;
  }
}
